import { render, staticRenderFns } from "./VendorTagSettings.vue?vue&type=template&id=6b43000d"
import script from "./VendorTagSettings.vue?vue&type=script&lang=js"
export * from "./VendorTagSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports